<style scoped lang="scss">
::v-deep .el-select .el-input {
  width: auto !important;
}
</style>
<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/material/inventory/record/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('wuliaomingcheng')">
            <!-- 跨组件 - 物料信息 -->
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_matter_list'" :min="1"-->
            <!--							:ids.sync="yt.conditions.materialIds"></yi_cross_select>-->
          </el-form-item>
          <!-- 产品分类(数据来源: 客户字典中code="GYLXCPFL"的所有字典值) -->
          <el-form-item :label="$t('chanpinfenlei')">
            <el-select filterable :clearable="true" v-model="yt.conditions.productType">
              <el-option v-for="(item, index) in productType" :key="index" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('cangkumingcheng')">
            <!-- 跨组件 - 仓库/库区/库位 warehouseIds的值说明:
						1.一次最多会传3个值到接口
						2.如果是3个值,那么第0位是仓库id(1开头),第二位是库区id(2开头),第三位是库位id(3开头),
						3.如果是2个值,那么第0位是库区id(2开头),第1位是库位id(3开头)
						4.如果是1个值,那么第0位是库位的值(3开头),后端收到请求后需截取掉第一位才能得到真正的id-->
            <yi_data_select :type="'warehouse'" :ids.sync="yt.conditions.warehouseIds"> </yi_data_select>
          </el-form-item>
          <!-- 交易类型 -->
          <el-form-item :label="$t('jiaoyileixing')">
            <yi_dictionary_select :type="'TRANSACTION_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <!-- 交易单号 -->
          <el-form-item :label="$t('jiaoyidanhao')">
            <el-input v-model="yt.conditions.transactionNo"></el-input>
          </el-form-item>
          <!-- 发生时间  时间区间查询条件 -->
          <el-form-item :label="$t('fashengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime"> </yi_time_input>
          </el-form-item>

          <!-- 操作人 -->
          <el-form-item :label="$t('caozuoren')">
            <el-input v-model="yt.conditions.operator"></el-input>
          </el-form-item>
          <!-- 客户名称 -->

          <el-form-item :label="$t('kehumingcheng')">
            <yi_data_select multiple :type="'wms_customer'" :width="'250px'" :ids.sync="yt.conditions.wmsCustomerIds"></yi_data_select>
            <!--  <yi_cross_select multiple :component="'web_wms_delivery_issue_customer_information'"
					      :ids.sync="yt.conditions.wmsCustomerId">
					  </yi_cross_select> -->
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
        <el-button size="mini" @click="summaryShow = true" type="primary" v-if="utils.checkPower('wms_material_inventory_record_list_summary')">
          {{ $t('churukuliushuihuizong') }}
        </el-button>
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
    <!-- 出入库流水汇总 -->
    <el-dialog :title="$t('churukuliushuihuizong')" :visible.sync="summaryShow" append-to-body="append-to-body" width="1200px">
      <div class="dialog-scroller">
        <inventoryRecordSummary v-if="summaryShow"></inventoryRecordSummary>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import inventoryRecordSummary from '@@/pages/web/wms/material_inventory_record/summary';
export default {
  name: 'wms_wms_material_inventory_record_list',
  components: {
    inventoryRecordSummary
  },
  data() {
    return {
      show: false,
      productType: [],
      warehouseList: [],
      colorNoEnable: false,
      summaryShow: false,
      columns: [
        {
          label: 'fashengshijian',
          prop: 'createTime',
          type: 'time',
          width: 150
        },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'jiaoyileixing',
          prop: 'type',
          type: 'dictionary',
          key: 'TRANSACTION_TYPE'
        },
        {
          label: 'jiaoyidanhao',
          prop: 'transactionNo'
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          show: false
        },
        {
          label: 'chanpinfenlei',
          prop: 'material.value',
          type: 'dictionary',
          key: 'GYLXCPFL'
        },
        {
          label: 'cangkubianma',
          prop: 'warehouse.code'
        },
        {
          label: 'cangkumingcheng',
          prop: 'warehouse.name'
        },
        {
          label: 'cangkudizhi',
          prop: 'warehouse.address'
        },
        {
          label: 'kuqubianma',
          prop: 'warehouseArea.code'
        },
        {
          label: 'kuqumingcheng',
          prop: 'warehouseArea.name'
        },
        {
          label: 'kuweibianma',
          prop: 'warehouseLocation.code'
        },
        {
          label: 'kuweimingcheng',
          prop: 'warehouseLocation.name'
        },
        {
          label: 'danwei',
          prop: 'unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
        },
        {
          label: 'jiaoyishuliang',
          prop: 'transactionQuantity'
        },
        {
          label: 'caozuoqiankucun',
          prop: 'oldQuantity'
        },
        {
          label: 'caozuohoukucun',
          prop: 'newQuantity'
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name'
        },
        {
          label: 'kehumingcheng',
          prop: 'wmsCustomer.name'
        },
        {
          label: 'wuliaopicihao',
          prop: 'materialBatchNo'
        },
        {
          label: 'shengchanpicihao',
          prop: 'productionBatchNo'
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 150
        },
        {
          label: "beizhu",
          prop: "remark",
        },
      ]
    };
  },

  created() {
    this.getProductionConfig();
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
      this.getProductType();
    }, 300);
  },
  methods: {
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumn('sehao');
        }
      });
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columns.length; i++) {
        const c = this.columns[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    // 请求查询客户数据字典中的产品分类
    async getProductType() {
      let response = await this.http.get('/web/config/customer/dictionary/item/getDictionaryByTypeCode', {
        params: {
          code: 'GYLXCPFL'
        }
      });
      this.productType = response.data;
      console.log(this.productType);
    },

    exportExcel() {
      let params = JSON.parse(JSON.stringify(this.yt.conditions));
      if (params.warehouseIds) {
        let warehouseId = params.warehouseIds[0] + '';
        params.warehouseIds = [];
        let fistChar = warehouseId.substring(0, 1);
        let paramChar = warehouseId.substring(1, warehouseId.length);
        if (fistChar === '1') {
          params.warehouseIds[0] = paramChar;
        } else if (fistChar === '2') {
          params.warehouseAreaId = paramChar;
        } else {
          params.warehouseLocationId = paramChar;
        }
      }
      if(params.startTime){
        params.createDateStart = params.startTime;
        params.createDateEnd = params.endTime;
      }
      return this.http
        .get('/web/report/export/wms_material_inventory_record_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    }
  }
};
</script>
